import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Front End Software Developer",
          "Systems Engineer",
          "Freelancer",
          "React js",
          "UI/UX Design",
          "Project Management",
          "IT Consultant For Various Companies"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 30,
      }}
    />
  );
}

export default Type;
